import { render, staticRenderFns } from "./EarningsType.vue?vue&type=template&id=6e6610b8&"
import script from "./EarningsType.vue?vue&type=script&lang=js&"
export * from "./EarningsType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports